/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earth_Day_2025_Donate_BtnInputs */

const en_earth_day_2025_donate_btn = /** @type {(inputs: Earth_Day_2025_Donate_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donate Forest Energy`)
};

const ar_earth_day_2025_donate_btn = /** @type {(inputs: Earth_Day_2025_Donate_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`امنح قوة Forest`)
};

const de_earth_day_2025_donate_btn = /** @type {(inputs: Earth_Day_2025_Donate_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gib Forest Power`)
};

const es_earth_day_2025_donate_btn = /** @type {(inputs: Earth_Day_2025_Donate_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dona poder de tu bosque`)
};

const fr_earth_day_2025_donate_btn = /** @type {(inputs: Earth_Day_2025_Donate_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donner du Pouvoir Forest`)
};

const it_earth_day_2025_donate_btn = /** @type {(inputs: Earth_Day_2025_Donate_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilizza Forest Power`)
};

const ja_earth_day_2025_donate_btn = /** @type {(inputs: Earth_Day_2025_Donate_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forestパワーを与える`)
};

const ko_earth_day_2025_donate_btn = /** @type {(inputs: Earth_Day_2025_Donate_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forest Power 기부하기`)
};

const pt_br_earth_day_2025_donate_btn = /** @type {(inputs: Earth_Day_2025_Donate_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doar Poder do Forest`)
};

const ru_earth_day_2025_donate_btn = /** @type {(inputs: Earth_Day_2025_Donate_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подарите силу Forest`)
};

const th_earth_day_2025_donate_btn = /** @type {(inputs: Earth_Day_2025_Donate_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ส่งมอบพลังแห่ง Forest`)
};

const tr_earth_day_2025_donate_btn = /** @type {(inputs: Earth_Day_2025_Donate_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forest Gücü Ver`)
};

const zh_cn_earth_day_2025_donate_btn = /** @type {(inputs: Earth_Day_2025_Donate_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`捐赠森林能量`)
};

const zh_tw_earth_day_2025_donate_btn = /** @type {(inputs: Earth_Day_2025_Donate_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`捐贈森林能量`)
};

/**
* | output |
* | --- |
* | "Donate Forest Energy" |
*
* @param {Earth_Day_2025_Donate_BtnInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const earth_day_2025_donate_btn = /** @type {((inputs?: Earth_Day_2025_Donate_BtnInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earth_Day_2025_Donate_BtnInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earth_day_2025_donate_btn(inputs)
	if (locale === "ar") return ar_earth_day_2025_donate_btn(inputs)
	if (locale === "de") return de_earth_day_2025_donate_btn(inputs)
	if (locale === "es") return es_earth_day_2025_donate_btn(inputs)
	if (locale === "fr") return fr_earth_day_2025_donate_btn(inputs)
	if (locale === "it") return it_earth_day_2025_donate_btn(inputs)
	if (locale === "ja") return ja_earth_day_2025_donate_btn(inputs)
	if (locale === "ko") return ko_earth_day_2025_donate_btn(inputs)
	if (locale === "pt_br") return pt_br_earth_day_2025_donate_btn(inputs)
	if (locale === "ru") return ru_earth_day_2025_donate_btn(inputs)
	if (locale === "th") return th_earth_day_2025_donate_btn(inputs)
	if (locale === "tr") return tr_earth_day_2025_donate_btn(inputs)
	if (locale === "zh_cn") return zh_cn_earth_day_2025_donate_btn(inputs)
	return zh_tw_earth_day_2025_donate_btn(inputs)
});